import type { IconNode } from '../types';

/**
 * @name square-kanban-plus
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgN3Y0IiAvPgogIDxwYXRoIGQ9Ik0xMi4zNTQgMjFINWEyIDIgMCAwMS0yLTJWNWEyIDIgMCAwMTItMmgxNGEyIDIgMCAwMTIgMnY3LjM1NCIgLz4KICA8cGF0aCBkPSJNMTUgMThoNiIgLz4KICA8cGF0aCBkPSJNMTYgN3Y0LjUzNiIgLz4KICA8cGF0aCBkPSJNMTggMjF2LTYiIC8+CiAgPHBhdGggZD0iTTggN3Y3IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/square-kanban-plus
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const SquareKanbanPlus: IconNode = [
  ['path', { d: 'M12 7v4' }],
  ['path', { d: 'M12.354 21H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v7.354' }],
  ['path', { d: 'M15 18h6' }],
  ['path', { d: 'M16 7v4.536' }],
  ['path', { d: 'M18 21v-6' }],
  ['path', { d: 'M8 7v7' }],
];

export default SquareKanbanPlus;
